import React from "react";
import { Link } from "react-router-dom";
import { FileSearch, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function DkDosyaPanel({
    dosyaQ,
    setDosyaQ,
    dosyalar,
    seciliDosya,
    onDosyaSec,
    onEkspertizDoldur,
    loading,
}) {
    return (
        <div className="rounded-2xl border border-white/10 bg-[#0c1222]/90 backdrop-blur p-4 space-y-3 shadow-xl">
            <h3 className="text-xs font-semibold uppercase tracking-wider text-slate-500">Dosya</h3>
            <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-slate-500" />
                <Input
                    placeholder="Plaka, dosya no, müvekkil..."
                    value={dosyaQ}
                    onChange={(e) => setDosyaQ(e.target.value)}
                    className="bg-black/40 border-white/10 h-10 pl-9"
                />
            </div>
            <select
                className="w-full h-10 rounded-lg bg-black/40 border border-white/10 text-sm text-white px-3"
                value={seciliDosya?.id || ""}
                onChange={(e) => {
                    const id = Number(e.target.value);
                    const d = dosyalar.find((x) => x.id === id);
                    onDosyaSec(d || null);
                }}
            >
                <option value="">Dosya seç (opsiyonel)</option>
                {dosyalar.map((d) => (
                    <option key={d.id} value={d.id}>
                        {d.dosya_no} {d.plaka ? `· ${d.plaka}` : ""}{" "}
                        {d.muvekkil_adi ? `· ${d.muvekkil_adi}` : ""}
                    </option>
                ))}
            </select>
            {seciliDosya ? (
                <>
                    <Link
                        to={seciliDosya.link || `/e/sigorta-dosyalari/${seciliDosya.id}`}
                        className="text-xs text-[#D4AF37] hover:underline block"
                    >
                        {seciliDosya.dosya_no} →
                    </Link>
                    <div className="flex flex-wrap gap-2">
                        <Button
                            size="sm"
                            variant="outline"
                            className="h-8 text-xs"
                            disabled={loading}
                            onClick={() => onEkspertizDoldur?.()}
                        >
                            <FileSearch className="h-3.5 w-3.5 mr-1" />
                            Ekspertizden doldur
                        </Button>
                        <Link
                            to={`/yeni/ekspertiz-hasar?dosya=${seciliDosya.id}`}
                            className="text-[10px] text-slate-500 hover:text-violet-300 self-center"
                        >
                            Hasar uzmanı →
                        </Link>
                    </div>
                </>
            ) : null}
        </div>
    );
}
